export enum ErrorSource {
  ANALYTICS_CLIENT = 'analyticsClient',
  PRODUCT_STORE = 'productStore',
  FEATURE_FLAGS_STORE = 'featureFlagsStore',
  USER_STORE = 'userStore',
}

export interface SentryTags {
  error_type?: string;
  report?: 'opsgenie-high';
  source?: ErrorSource;
}
